import { ChangeDetectorRef, inject, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { Subscription } from 'rxjs';

import { I18nService } from '../../core/services/i18n.service';

@Pipe({
  name: 'paymentText',
  standalone: true,
  pure: false
})
export class PaymentTextPipe implements PipeTransform, OnDestroy {
  
  private i18nService = inject(I18nService);
  private cdr = inject(ChangeDetectorRef);
  private langSubscription: Subscription;

  constructor() {
    this.langSubscription = this.i18nService.getCurrentLanguage().subscribe(() => {
      this.cdr.markForCheck();
    });
  }

  transform(cardType: string | undefined, cardLastFourDigits?: string | undefined, flow?: 'MOVEL' | 'BOLETO_CARTAO' | undefined): string {
    if ((!cardType && !flow) || (!cardType && flow === 'BOLETO_CARTAO')) {
      return this.i18nService.instant('shared.labels.bankSlip');
    } 
    if (!cardType && flow === 'MOVEL') {
      return 'Fatura Claro';
    }
    
    const last4 = cardLastFourDigits && cardLastFourDigits.trim() ? cardLastFourDigits : '0000';
    
    return this.i18nService.instant('pipes.paymentText.endingIn', { last4 });
  }

  ngOnDestroy(): void {
    if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }
  }
}